import { Loader2 } from "lucide-react"; // O el icono que uses

interface FullScreenLoaderProps {
  label?: string;
}

export function FullScreenLoader({ label }: FullScreenLoaderProps) {
  return (
    <div className="flex h-screen w-full flex-col items-center justify-center gap-3 bg-background">
      {label ? (
        // Si hay texto (ej: en el AppGate), mostramos el spinner clásico + texto
        <div className="flex flex-col items-center gap-3">
          <Loader2 className="h-8 w-8 animate-spin text-primary" />
          <p className="text-xs font-semibold text-muted-foreground animate-pulse">
            {label}
          </p>
        </div>
      ) : (
        // 🌟 Si NO hay texto (en el arranque técnico), mostramos el logo corporativo animado
        <div className="relative flex items-center justify-center">
          <img
            src="/favicon.svg" // O tu componente <Logo />
            className="h-12 w-12 animate-pulse opacity-80"
            alt="Fysaro"
          />
        </div>
      )}
    </div>
  );
}
